// @flow

import * as React from 'react';
import { Component } from 'react';
import styled from 'styled-components';
import { IsMediumScreen } from '../Media';
import { PhoneIcon, ChatIcon, BookMeetingIcon } from '../Icons';
import ServiceBarItem from './ServiceBarItem';
import CallUsPanel from './CallUsPanel';
import { ServiceBarContext } from './ServiceBarProvider';
import type { ServiceBarProps } from './ServiceBarProvider';

type State = {
  panelIsHidden: boolean,
};

export default class ServiceBar extends Component<ServiceBarProps, State> {
  state = {
    panelIsHidden: true,
  };

  static contextType = ServiceBarContext;
  panelContainerRef: { current: null | any };

  constructor() {
    super();
    // $FlowFixMe
    this.panelContainerRef = React.createRef();
  }

  componentDidUpdate() {
    if (!this.state.panelIsHidden) {
      setTimeout(() => {
        if (this.panelContainerRef.current != null) {
          this.panelContainerRef.current.focus();
        }
      }, 50);
    }
  }

  render() {
    const finalProps = { ...this.context, ...this.props };
    const {
      showCallUs,
      showChat,
      showBookMeeting,
      callUsPanelHeader,
      callUsPhoneNumberText,
      wealthCustomer,
      callUsOpeningHours,
      callUsInformation,
      callUsCallPrivatBanker,
    } = finalProps;
    const { panelIsHidden } = this.state;

    return (
      <IsMediumScreen>
        <ServiceBarContainer>
          <ButtonsList panelIsHidden={panelIsHidden}>
            {showCallUs && this.renderCallUsButton()}
            {showChat && this.renderChatButton()}
            {showBookMeeting && this.renderBookMeetingButton()}
          </ButtonsList>
          <PanelContainer
            ref={this.panelContainerRef}
            tabIndex="0"
            onBlur={this.closePanel}
            panelIsHidden={panelIsHidden}
          >
            <CallUsPanel
              callUsPanelHeader={callUsPanelHeader}
              callUsPhoneNumberText={callUsPhoneNumberText}
              wealthCustomer={wealthCustomer}
              callUsInformation={callUsInformation}
              callUsCallPrivatBanker={callUsCallPrivatBanker}
              callUsOpeningHours={
                this.isStringAndEmpty(callUsOpeningHours)
                  ? null
                  : callUsOpeningHours
              }
            />
          </PanelContainer>
        </ServiceBarContainer>
      </IsMediumScreen>
    );
  }

  renderCallUsButton = () => {
    const finalProps = { ...this.context, ...this.props };
    const { callUsButtonLabel } = finalProps;

    return (
      <ServiceBarItem
        panelIsHidden={this.state.panelIsHidden}
        onMouseDown={this.onMouseDownCallUsButton}
        id="CallUsButton"
        Icon={PhoneIcon}
        label={callUsButtonLabel}
      />
    );
  };

  renderChatButton = () => {
    const finalProps = { ...this.context, ...this.props };
    const { chatButtonLabel } = finalProps;

    return (
      <ServiceBarItem
        panelIsHidden={this.state.panelIsHidden}
        onClick={this.onClickChatButton}
        id="ChatButton"
        Icon={ChatIcon}
        label={chatButtonLabel}
      />
    );
  };

  renderBookMeetingButton = () => {
    const finalProps = { ...this.context, ...this.props };
    const { bookMeetingButtonLabel } = finalProps;

    return (
      <ServiceBarItem
        panelIsHidden={this.state.panelIsHidden}
        onClick={this.onClickBookMeetingButton}
        id="BookMeetingButton"
        Icon={BookMeetingIcon}
        label={bookMeetingButtonLabel}
      />
    );
  };

  onMouseDownCallUsButton = (e: any) => {
    e.preventDefault();
    this.togglePanel();
  };

  togglePanel = () => {
    this.setState((prevState) => {
      return {
        panelIsHidden: !prevState.panelIsHidden,
      };
    });
  };

  closePanel = () => {
    if (!this.state.panelIsHidden) {
      this.setState({ panelIsHidden: true });
    }
  };

  onClickChatButton = (e: any) => {
    e.preventDefault();
    this.closePanel();

    const finalProps = { ...this.context, ...this.props };
    const { chatButtonLink } = finalProps;

    window.open(
      chatButtonLink,
      'Danske_Bank',
      'height=600,width=435,resizable=no,scrollbars=no,toolbar=no,status=no'
    );
  };

  onClickBookMeetingButton = (e: any) => {
    e.preventDefault();
    this.closePanel();

    const finalProps = { ...this.context, ...this.props };
    const { bookMeetingButtonLink } = finalProps;

    window.open(
      bookMeetingButtonLink,
      'Danske_Bank',
      'location=yes,height=570,width=520,scrollbars=yes,status=yes'
    );
  };

  isStringAndEmpty = (val: any) => {
    return typeof val === 'string' && (val.length === 0 || !val.trim());
  };
}

const ButtonsList = styled.ul`
  position: relative;
  z-index: 502;
  color: #003755;
  transition: all 0.2s linear;
  font-size: 0;
  margin: 0;
  list-style-position: outside;
  line-height: 1.6;
  list-style-type: none;
  padding: 0;
  box-shadow: ${(props) =>
    props.panelIsHidden
      ? '0 0 14px 0 rgba(0, 0, 0, 0.07)'
      : '0 14px 14px 0 rgba(0, 0, 0, 0.07)'};
`;

const PanelContainer = styled.div`
  position: fixed;
  width: 335px;
  right: 0;
  bottom: ${(props) => (props.panelIsHidden ? 0 : '79px')};
  z-index: 500;
  overflow: hidden;
  background-color: #fff;
  border: 1px solid #e5e5e5;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  border-right: 0;
  box-shadow: 0 0 40px 0 rgba(0, 0, 0, 0.05);
  opacity: ${(props) => (props.panelIsHidden ? 0 : 1)};
  visibility: ${(props) => (props.panelIsHidden ? 'hidden' : 'visible')};
  transition: all 0.2s linear;

  &:focus {
    outline: 0;
  }
`;

const ServiceBarContainer = styled.div`
  position: fixed;
  bottom: 10px;
  right: 0px;
  z-index: 500;
`;
